(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CalimaCrea"] && !Shopify.designMode) return;
  try {
    
(function () {
  var cabecera = document.getElementById('hdr-cabecera');
  var btnMenu = document.getElementById('hdr-btn-menu');
  var overlay = document.getElementById('hdr-overlay');
  var btnBusqueda = document.getElementById('hdr-btn-busqueda');
  var barraBusqueda = document.getElementById('hdr-busqueda-barra');
  var btnBusquedaCerrar = document.getElementById('hdr-busqueda-cerrar');
  var portal = document.getElementById('hdr-megamenus-portal');
  var btnCarrito = document.getElementById('hdr-btn-carrito');

  if (portal && portal.parentNode !== document.body) {
    document.body.appendChild(portal);
  }

  if (btnCarrito) {
    btnCarrito.addEventListener('click', function () {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open(btnCarrito);
      } else if (cartDrawer) {
        cartDrawer.removeAttribute('hidden');
        cartDrawer.setAttribute('open', '');
        document.dispatchEvent(new CustomEvent('cart:open'));
      } else {
        window.location = '{{ routes.cart_url }}';
      }
    });
  }

  document.addEventListener('cart:refresh', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var badge = document.getElementById('hdr-carrito-badge');
        if (badge) {
          badge.textContent = data.item_count;
          badge.style.display = data.item_count > 0 ? 'flex' : 'none';
        }
      });
  });

  function getAlturaCabecera() {
    if (!cabecera) return 0;
    var rect = cabecera.getBoundingClientRect();
    return rect.bottom + window.scrollY;
  }

  function posicionarMegamenus() {
    var top = getAlturaCabecera();
    document.querySelectorAll('.hdr-megamenu').forEach(function (m) {
      m.style.top = top + 'px';
    });
  }

  posicionarMegamenus();
  window.addEventListener('scroll', posicionarMegamenus, { passive: true });
  window.addEventListener('resize', posicionarMegamenus);

  if (cabecera) {
    window.addEventListener('scroll', function () {
      cabecera.classList.toggle('hdr-cabecera--scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  var megaActivo = null;
  var itemActivo = null;
  var timeoutCierre = null;

  function abrirMega(item) {
    var id = item.getAttribute('data-mega-id');
    if (!id) return;
    var mega = document.getElementById(id);
    if (!mega) return;
    if (megaActivo && megaActivo !== mega) cerrarMega(megaActivo, itemActivo);
    clearTimeout(timeoutCierre);
    posicionarMegamenus();
    mega.classList.add('hdr-megamenu--visible');
    mega.setAttribute('aria-hidden', 'false');
    item.classList.add('hdr-nav__item--activo');
    var enlace = item.querySelector('.hdr-nav__enlace');
    if (enlace) enlace.setAttribute('aria-expanded', 'true');
    overlay.classList.add('hdr-overlay--visible');
    megaActivo = mega;
    itemActivo = item;
  }

  function cerrarMega(mega, item) {
    if (!mega) return;
    mega.classList.remove('hdr-megamenu--visible');
    mega.setAttribute('aria-hidden', 'true');
    if (item) {
      item.classList.remove('hdr-nav__item--activo');
      var enlace = item.querySelector('.hdr-nav__enlace');
      if (enlace) enlace.setAttribute('aria-expanded', 'false');
    }
    if (!document.querySelector('.hdr-nav-movil--abierto') && !barraBusqueda.classList.contains('hdr-busqueda-barra--visible')) {
      overlay.classList.remove('hdr-overlay--visible');
    }
    megaActivo = null;
    itemActivo = null;
  }

  function cerrarTodosMega() {
    document.querySelectorAll('.hdr-megamenu--visible').forEach(function (m) {
      m.classList.remove('hdr-megamenu--visible');
      m.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.hdr-nav__item--activo').forEach(function (i) {
      i.classList.remove('hdr-nav__item--activo');
      var e = i.querySelector('.hdr-nav__enlace');
      if (e) e.setAttribute('aria-expanded', 'false');
    });
    megaActivo = null;
    itemActivo = null;
  }

  document.querySelectorAll('.hdr-nav__item--mega').forEach(function (item) {
    var id = item.getAttribute('data-mega-id');
    var mega = id ? document.getElementById(id) : null;
    if (!mega) return;

    item.addEventListener('mouseenter', function () { abrirMega(item); });
    item.addEventListener('mouseleave', function () {
      timeoutCierre = setTimeout(function () { cerrarMega(mega, item); }, 120);
    });
    mega.addEventListener('mouseenter', function () { clearTimeout(timeoutCierre); });
    mega.addEventListener('mouseleave', function () {
      timeoutCierre = setTimeout(function () { cerrarMega(mega, item); }, 120);
    });

    var enlace = item.querySelector('.hdr-nav__enlace');
    if (enlace) {
      enlace.addEventListener('click', function (e) {
        if (window.innerWidth >= 990) {
          e.preventDefault();
          if (item.classList.contains('hdr-nav__item--activo')) {
            cerrarMega(mega, item);
          } else {
            abrirMega(item);
          }
        }
      });
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.hdr-nav__item--mega') && !e.target.closest('.hdr-megamenu')) {
      cerrarTodosMega();
      if (!document.querySelector('.hdr-nav-movil--abierto') && !barraBusqueda.classList.contains('hdr-busqueda-barra--visible')) {
        overlay.classList.remove('hdr-overlay--visible');
      }
    }
  });

  var navMovil = document.createElement('nav');
  navMovil.className = 'hdr-nav-movil';
  navMovil.setAttribute('aria-label', 'Navegación móvil');
  var nombreTienda = document.querySelector('.hdr-cabecera__logo-texto');
  var tituloMovil = nombreTienda ? nombreTienda.textContent.trim() : 'Menú';
  navMovil.innerHTML = '<div class="hdr-nav-movil__cabecera"><p class="hdr-nav-movil__titulo">' + tituloMovil + '</p><button class="hdr-nav-movil__cerrar" id="hdr-movil-cerrar" aria-label="Cerrar menú"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div><ul class="hdr-nav-movil__lista" id="hdr-movil-lista"></ul>';
  document.body.appendChild(navMovil);

  var listaMovil = navMovil.querySelector('#hdr-movil-lista');
  var itemsDesktop = document.querySelectorAll('.hdr-nav__item');

  itemsDesktop.forEach(function (item) {
    var enlaceD = item.querySelector('.hdr-nav__enlace');
    if (!enlaceD) return;
    var tieneMega = item.classList.contains('hdr-nav__item--mega');
    var li = document.createElement('li');

    if (tieneMega) {
      var id = item.getAttribute('data-mega-id');
      var megaRef = id ? document.getElementById(id) : null;
      var btn = document.createElement('button');
      btn.className = 'hdr-nav-movil__enlace';
      var textoBase = enlaceD.cloneNode(true);
      textoBase.querySelectorAll('.hdr-nav__chevron').forEach(function (c) { c.remove(); });
      btn.textContent = textoBase.textContent.trim();
      btn.innerHTML += '<span class="hdr-nav-movil__chevron"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg></span>';
      var submenu = document.createElement('div');
      submenu.className = 'hdr-nav-movil__submenu';
      if (megaRef) {
        megaRef.querySelectorAll('.hdr-megamenu__columna').forEach(function (col) {
          var titulo = col.querySelector('.hdr-megamenu__titulo-col');
          var enlaces = col.querySelectorAll('.hdr-megamenu__enlace');
          if (titulo) {
            var p = document.createElement('p');
            p.className = 'hdr-nav-movil__subtitulo';
            p.textContent = titulo.textContent.trim();
            submenu.appendChild(p);
          }
          enlaces.forEach(function (e) {
            var a = document.createElement('a');
            a.className = 'hdr-nav-movil__subenlace';
            a.href = e.href;
            a.textContent = e.textContent.trim();
            submenu.appendChild(a);
          });
        });
      }
      btn.addEventListener('click', function () {
        var abierto = submenu.classList.contains('hdr-nav-movil__submenu--visible');
        listaMovil.querySelectorAll('.hdr-nav-movil__submenu--visible').forEach(function (s) { s.classList.remove('hdr-nav-movil__submenu--visible'); });
        listaMovil.querySelectorAll('.hdr-nav-movil__enlace--activo').forEach(function (b) { b.classList.remove('hdr-nav-movil__enlace--activo'); });
        if (!abierto) {
          submenu.classList.add('hdr-nav-movil__submenu--visible');
          btn.classList.add('hdr-nav-movil__enlace--activo');
        }
      });
      li.appendChild(btn);
      li.appendChild(submenu);
    } else {
      var a = document.createElement('a');
      a.className = 'hdr-nav-movil__enlace';
      a.href = enlaceD.getAttribute('href') || '#';
      var clon = enlaceD.cloneNode(true);
      clon.querySelectorAll('.hdr-nav__chevron').forEach(function (c) { c.remove(); });
      a.textContent = clon.textContent.trim();
      li.appendChild(a);
    }
    listaMovil.appendChild(li);
  });

  function abrirMenuMovil() {
    navMovil.classList.add('hdr-nav-movil--abierto');
    overlay.classList.add('hdr-overlay--visible');
    btnMenu.classList.add('hdr--abierto');
    btnMenu.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function cerrarMenuMovil() {
    navMovil.classList.remove('hdr-nav-movil--abierto');
    btnMenu.classList.remove('hdr--abierto');
    btnMenu.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (!barraBusqueda.classList.contains('hdr-busqueda-barra--visible')) {
      overlay.classList.remove('hdr-overlay--visible');
    }
  }

  if (btnMenu) btnMenu.addEventListener('click', abrirMenuMovil);
  var btnMovilCerrar = document.getElementById('hdr-movil-cerrar');
  if (btnMovilCerrar) btnMovilCerrar.addEventListener('click', cerrarMenuMovil);
  if (overlay) overlay.addEventListener('click', function () {
    cerrarMenuMovil();
    cerrarBusqueda();
    cerrarTodosMega();
  });

  function abrirBusqueda() {
    barraBusqueda.classList.add('hdr-busqueda-barra--visible');
    barraBusqueda.setAttribute('aria-hidden', 'false');
    overlay.classList.add('hdr-overlay--visible');
    setTimeout(function () {
      var input = barraBusqueda.querySelector('.hdr-busqueda-barra__input');
      if (input) input.focus();
    }, 150);
  }

  function cerrarBusqueda() {
    barraBusqueda.classList.remove('hdr-busqueda-barra--visible');
    barraBusqueda.setAttribute('aria-hidden', 'true');
    if (!navMovil.classList.contains('hdr-nav-movil--abierto')) {
      overlay.classList.remove('hdr-overlay--visible');
    }
  }

  if (btnBusqueda) btnBusqueda.addEventListener('click', abrirBusqueda);
  if (btnBusquedaCerrar) btnBusquedaCerrar.addEventListener('click', cerrarBusqueda);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      cerrarMenuMovil();
      cerrarBusqueda();
      cerrarTodosMega();
      overlay.classList.remove('hdr-overlay--visible');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-banners-calima"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[id^="cb-seccion-"]').forEach(function (seccion) {
    var id = seccion.id.replace('cb-seccion-', '');
    var pista = document.getElementById('cb-pista-' + id);
    var carril = document.getElementById('cb-carril-' + id);
    var contenedorPuntos = document.getElementById('cb-puntos-' + id);
    var btnPrev = document.getElementById('cb-prev-' + id);
    var btnNext = document.getElementById('cb-next-' + id);

    if (!carril) return;

    var slides = Array.from(carril.querySelectorAll('.cb-slide'));
    var puntos = contenedorPuntos ? Array.from(contenedorPuntos.querySelectorAll('.cb-puntos__punto')) : [];
    var total = slides.length;
    var indiceActual = 0;
    var anchoSlide = 0;
    var visibles = 1;
    var autoplayTimer = null;
    var autoplayMs = parseInt(seccion.getAttribute('data-autoplay') || '0', 10);
    var columnasConfig = parseInt(seccion.getAttribute('data-columnas') || '3', 10);

    function calcularVisibles() {
      var w = window.innerWidth;
      var colClass = slides[0] ? (slides[0].className.match(/cb-slide--col-(\d)/) || [])[1] : null;
      if (w >= 990) {
        visibles = columnasConfig;
      } else if (w >= 749) {
        visibles = 2;
      } else {
        visibles = 1;
      }
      anchoSlide = slides[0] ? slides[0].offsetWidth : pista.offsetWidth / visibles;
    }

    function irA(idx) {
      var maxIdx = Math.max(0, total - visibles);
      indiceActual = Math.min(Math.max(idx, 0), maxIdx);
      carril.style.transform = 'translateX(-' + (indiceActual * anchoSlide) + 'px)';

      puntos.forEach(function (p, i) {
        p.classList.toggle('cb-puntos__punto--activo', i === indiceActual);
        p.setAttribute('aria-selected', i === indiceActual ? 'true' : 'false');
      });

      if (btnPrev) btnPrev.style.opacity = indiceActual === 0 ? '0.4' : '1';
      if (btnNext) btnNext.style.opacity = indiceActual >= total - visibles ? '0.4' : '1';
    }

    function siguiente() { irA(indiceActual + 1 < total ? indiceActual + 1 : 0); }
    function anterior() { irA(indiceActual - 1 >= 0 ? indiceActual - 1 : total - 1); }

    calcularVisibles();

    slides.forEach(function (slide) {
      slide.classList.remove('cb-slide--col-2', 'cb-slide--col-3', 'cb-slide--col-4');
      slide.classList.add('cb-slide--col-' + visibles);
      slide.style.flex = '0 0 ' + (100 / visibles) + '%';
      slide.style.maxWidth = (100 / visibles) + '%';
    });

    irA(0);

    window.addEventListener('resize', function () {
      calcularVisibles();
      slides.forEach(function (slide) {
        slide.style.flex = '0 0 ' + (100 / visibles) + '%';
        slide.style.maxWidth = (100 / visibles) + '%';
      });
      irA(Math.min(indiceActual, Math.max(0, total - visibles)));
    });

    if (btnPrev) btnPrev.addEventListener('click', function () { anterior(); reiniciarAutoplay(); });
    if (btnNext) btnNext.addEventListener('click', function () { siguiente(); reiniciarAutoplay(); });

    puntos.forEach(function (punto) {
      punto.addEventListener('click', function () {
        irA(parseInt(punto.getAttribute('data-indice'), 10));
        reiniciarAutoplay();
      });
    });

    var arrastrandoDesde = null;
    var offsetArrastre = 0;
    var umbral = 50;

    function onDragStart(x) {
      arrastrandoDesde = x;
      offsetArrastre = 0;
      carril.style.transition = 'none';
    }

    function onDragMove(x) {
      if (arrastrandoDesde === null) return;
      offsetArrastre = x - arrastrandoDesde;
      carril.style.transform = 'translateX(' + (-indiceActual * anchoSlide + offsetArrastre) + 'px)';
    }

    function onDragEnd() {
      if (arrastrandoDesde === null) return;
      carril.style.transition = '';
      if (offsetArrastre < -umbral) siguiente();
      else if (offsetArrastre > umbral) anterior();
      else irA(indiceActual);
      arrastrandoDesde = null;
      reiniciarAutoplay();
    }

    pista.addEventListener('mousedown', function (e) { onDragStart(e.clientX); });
    window.addEventListener('mousemove', function (e) { onDragMove(e.clientX); });
    window.addEventListener('mouseup', onDragEnd);

    pista.addEventListener('touchstart', function (e) { onDragStart(e.touches[0].clientX); }, { passive: true });
    pista.addEventListener('touchmove', function (e) { onDragMove(e.touches[0].clientX); }, { passive: true });
    pista.addEventListener('touchend', onDragEnd);

    function iniciarAutoplay() {
      if (!autoplayMs) return;
      autoplayTimer = setInterval(siguiente, autoplayMs);
    }

    function reiniciarAutoplay() {
      clearInterval(autoplayTimer);
      iniciarAutoplay();
    }

    iniciarAutoplay();

    seccion.addEventListener('mouseenter', function () { clearInterval(autoplayTimer); });
    seccion.addEventListener('mouseleave', iniciarAutoplay);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalizador"] && !Shopify.designMode) return;
  try {
    
(function () {
  var canvas = document.getElementById('pz-canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var canvasPreview = document.getElementById('pz-canvas-preview');
  var ctxPreview = canvasPreview ? canvasPreview.getContext('2d') : null;

  var state = {
    elementos: [],
    seleccionado: null,
    fondoColor: 'transparent',
    historial: [],
    historialIndice: -1,
    arrastrandoEl: null,
    offsetArrastreX: 0,
    offsetArrastreY: 0,
    redimensionando: false
  };

  var hint = document.getElementById('pz-canvas-hint');

  function guardarHistorial() {
    state.historial = state.historial.slice(0, state.historialIndice + 1);
    state.historial.push(JSON.parse(JSON.stringify(state.elementos)));
    state.historialIndice++;
  }

  function dibujar() {
    var w = canvas.width;
    var h = canvas.height;
    ctx.clearRect(0, 0, w, h);

    if (state.fondoColor !== 'transparent') {
      ctx.fillStyle = state.fondoColor;
      ctx.fillRect(0, 0, w, h);
    }

    state.elementos.forEach(function (el) {
      ctx.save();
      ctx.globalAlpha = el.opacidad;
      var cx = el.x + el.ancho / 2;
      var cy = el.y + el.alto / 2;
      ctx.translate(cx, cy);
      ctx.rotate(el.rotacion * Math.PI / 180);

      if (el.tipo === 'imagen' && el.imgObj) {
        ctx.drawImage(el.imgObj, -el.ancho / 2, -el.alto / 2, el.ancho, el.alto);
      } else if (el.tipo === 'texto') {
        var estilo = (el.cursiva ? 'italic ' : '') + (el.negrita ? 'bold ' : '');
        ctx.font = estilo + el.tamano + 'px ' + el.fuente;
        ctx.fillStyle = el.color;
        ctx.textBaseline = 'middle';
        ctx.fillText(el.contenido, -el.ancho / 2, 0);
      }

      if (state.seleccionado === el) {
        ctx.strokeStyle = '#F5C518';
        ctx.lineWidth = 2;
        ctx.setLineDash([6, 3]);
        ctx.strokeRect(-el.ancho / 2 - 4, -el.alto / 2 - 4, el.ancho + 8, el.alto + 8);
        ctx.setLineDash([]);
        ctx.fillStyle = '#F5C518';
        ctx.fillRect(el.ancho / 2, el.alto / 2, 10, 10);
      }

      ctx.restore();
    });

    if (hint) hint.style.opacity = state.elementos.length === 0 ? '1' : '0';
    actualizarPreview();
    actualizarCapas();
  }

  function actualizarPreview() {
    if (!ctxPreview || !canvasPreview) return;
    var pw = canvasPreview.width = canvasPreview.offsetWidth;
    var ph = canvasPreview.height = canvasPreview.offsetHeight;
    ctxPreview.clearRect(0, 0, pw, ph);
    ctxPreview.drawImage(canvas, 0, 0, pw, ph);
  }

  function actualizarCapas() {
    var lista = document.getElementById('pz-capas-lista');
    var acciones = document.getElementById('pz-capas-acciones');
    if (!lista) return;
    lista.innerHTML = '';
    if (state.elementos.length === 0) {
      lista.innerHTML = '<li class="pz-capas__vacia">Aún no hay elementos en el diseño</li>';
      if (acciones) acciones.style.display = 'none';
      return;
    }
    if (acciones) acciones.style.display = 'flex';
    var invertidos = state.elementos.slice().reverse();
    invertidos.forEach(function (el, i) {
      var idx = state.elementos.length - 1 - i;
      var li = document.createElement('li');
      li.className = 'pz-capa-item' + (state.seleccionado === el ? ' pz-capa-item--activa' : '');
      li.innerHTML = '<span class="pz-capa-item__icono">' + (el.tipo === 'imagen' ? '🖼' : '✏️') + '</span><span>' + (el.tipo === 'imagen' ? 'Imagen' : el.contenido.substring(0, 20)) + '</span>';
      li.addEventListener('click', function () { seleccionar(el); dibujar(); });
      lista.appendChild(li);
    });
  }

  function seleccionar(el) {
    state.seleccionado = el;
    var props = document.getElementById('pz-props');
    if (props) props.style.display = el ? 'block' : 'none';
    if (el) {
      document.getElementById('pz-prop-opacidad').value = el.opacidad * 100;
      document.getElementById('pz-prop-opacidad-val').textContent = Math.round(el.opacidad * 100);
      document.getElementById('pz-prop-rotacion').value = el.rotacion;
      document.getElementById('pz-prop-rotacion-val').textContent = el.rotacion;
    }
  }

  function getPos(e, el) {
    var rect = canvas.getBoundingClientRect();
    var scaleX = canvas.width / rect.width;
    var scaleY = canvas.height / rect.height;
    var clientX = e.touches ? e.touches[0].clientX : e.clientX;
    var clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return {
      x: (clientX - rect.left) * scaleX,
      y: (clientY - rect.top) * scaleY
    };
  }

  function hitTest(pos) {
    for (var i = state.elementos.length - 1; i >= 0; i--) {
      var el = state.elementos[i];
      if (pos.x >= el.x && pos.x <= el.x + el.ancho && pos.y >= el.y && pos.y <= el.y + el.alto) {
        return el;
      }
    }
    return null;
  }

  function onDown(e) {
    e.preventDefault();
    var pos = getPos(e);
    var hit = hitTest(pos);
    if (hit) {
      seleccionar(hit);
      var handleX = hit.x + hit.ancho;
      var handleY = hit.y + hit.alto;
      if (Math.abs(pos.x - handleX) < 15 && Math.abs(pos.y - handleY) < 15) {
        state.redimensionando = true;
        state.arrastrandoEl = hit;
      } else {
        state.arrastrandoEl = hit;
        state.offsetArrastreX = pos.x - hit.x;
        state.offsetArrastreY = pos.y - hit.y;
        state.redimensionando = false;
      }
    } else {
      seleccionar(null);
      state.arrastrandoEl = null;
    }
    dibujar();
  }

  function onMove(e) {
    if (!state.arrastrandoEl) return;
    e.preventDefault();
    var pos = getPos(e);
    var el = state.arrastrandoEl;
    if (state.redimensionando) {
      var nuevaAncho = Math.max(20, pos.x - el.x);
      var ratio = nuevaAncho / el.ancho;
      el.ancho = nuevaAncho;
      el.alto = el.alto * ratio;
    } else {
      el.x = pos.x - state.offsetArrastreX;
      el.y = pos.y - state.offsetArrastreY;
    }
    dibujar();
  }

  function onUp() {
    if (state.arrastrandoEl) guardarHistorial();
    state.arrastrandoEl = null;
    state.redimensionando = false;
  }

  canvas.addEventListener('mousedown', onDown);
  window.addEventListener('mousemove', onMove);
  window.addEventListener('mouseup', onUp);
  canvas.addEventListener('touchstart', onDown, { passive: false });
  canvas.addEventListener('touchmove', onMove, { passive: false });
  canvas.addEventListener('touchend', onUp);

  document.getElementById('pz-input-imagen').addEventListener('change', function (e) {
    var file = e.target.files[0];
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function (ev) {
      var img = new Image();
      img.onload = function () {
        var ratio = img.width / img.height;
        var ancho = Math.min(200, canvas.width * 0.4);
        var alto = ancho / ratio;
        var el = {
          tipo: 'imagen',
          imgObj: img,
          x: canvas.width / 2 - ancho / 2,
          y: canvas.height / 2 - alto / 2,
          ancho: ancho,
          alto: alto,
          opacidad: 1,
          rotacion: 0
        };
        state.elementos.push(el);
        seleccionar(el);
        guardarHistorial();
        dibujar();

        var miniaturas = document.getElementById('pz-miniaturas');
        var thumb = document.createElement('img');
        thumb.src = ev.target.result;
        thumb.className = 'pz-miniatura pz-miniatura--activa';
        thumb.addEventListener('click', function () { seleccionar(el); dibujar(); });
        miniaturas.appendChild(thumb);

        if (hint) hint.style.opacity = '0';
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  });

  var negrita = false, cursiva = false;

  document.getElementById('pz-texto-negrita').addEventListener('click', function () {
    negrita = !negrita;
    this.classList.toggle('pz-formato__btn--activo', negrita);
  });

  document.getElementById('pz-texto-cursiva').addEventListener('click', function () {
    cursiva = !cursiva;
    this.classList.toggle('pz-formato__btn--activo', cursiva);
  });

  document.getElementById('pz-texto-tamano').addEventListener('input', function () {
    document.getElementById('pz-texto-tamano-val').textContent = this.value;
  });

  document.getElementById('pz-btn-anadir-texto').addEventListener('click', function () {
    var texto = document.getElementById('pz-texto-input').value.trim();
    if (!texto) return;
    var fuente = document.getElementById('pz-texto-fuente').value;
    var tamano = parseInt(document.getElementById('pz-texto-tamano').value);
    var color = document.getElementById('pz-texto-color').value;

    ctx.font = (cursiva ? 'italic ' : '') + (negrita ? 'bold ' : '') + tamano + 'px ' + fuente;
    var ancho = ctx.measureText(texto).width;
    var alto = tamano * 1.2;

    var el = {
      tipo: 'texto',
      contenido: texto,
      fuente: fuente,
      tamano: tamano,
      color: color,
      negrita: negrita,
      cursiva: cursiva,
      x: canvas.width / 2 - ancho / 2,
      y: canvas.height / 2 - alto / 2,
      ancho: ancho,
      alto: alto,
      opacidad: 1,
      rotacion: 0
    };
    state.elementos.push(el);
    seleccionar(el);
    guardarHistorial();
    dibujar();
  });

  document.querySelectorAll('.pz-color-chip').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.pz-color-chip').forEach(function (b) { b.classList.remove('pz-color-chip--activo'); });
      btn.classList.add('pz-color-chip--activo');
      state.fondoColor = btn.getAttribute('data-color');
      dibujar();
    });
  });

  document.getElementById('pz-fondo-color-custom').addEventListener('input', function () {
    document.querySelectorAll('.pz-color-chip').forEach(function (b) { b.classList.remove('pz-color-chip--activo'); });
    state.fondoColor = this.value;
    dibujar();
  });

  document.getElementById('pz-prop-opacidad').addEventListener('input', function () {
    if (state.seleccionado) {
      state.seleccionado.opacidad = this.value / 100;
      document.getElementById('pz-prop-opacidad-val').textContent = this.value;
      dibujar();
    }
  });

  document.getElementById('pz-prop-rotacion').addEventListener('input', function () {
    if (state.seleccionado) {
      state.seleccionado.rotacion = parseInt(this.value);
      document.getElementById('pz-prop-rotacion-val').textContent = this.value;
      dibujar();
    }
  });

  document.getElementById('pz-btn-subir').addEventListener('click', function () {
    if (!state.seleccionado) return;
    var idx = state.elementos.indexOf(state.seleccionado);
    if (idx < state.elementos.length - 1) {
      var tmp = state.elementos[idx + 1];
      state.elementos[idx + 1] = state.elementos[idx];
      state.elementos[idx] = tmp;
      guardarHistorial();
      dibujar();
    }
  });

  document.getElementById('pz-btn-bajar').addEventListener('click', function () {
    if (!state.seleccionado) return;
    var idx = state.elementos.indexOf(state.seleccionado);
    if (idx > 0) {
      var tmp = state.elementos[idx - 1];
      state.elementos[idx - 1] = state.elementos[idx];
      state.elementos[idx] = tmp;
      guardarHistorial();
      dibujar();
    }
  });

  document.getElementById('pz-btn-eliminar').addEventListener('click', function () {
    if (!state.seleccionado) return;
    state.elementos = state.elementos.filter(function (e) { return e !== state.seleccionado; });
    seleccionar(null);
    guardarHistorial();
    dibujar();
  });

  document.getElementById('pz-btn-deshacer').addEventListener('click', function () {
    if (state.historialIndice > 0) {
      state.historialIndice--;
      state.elementos = JSON.parse(JSON.stringify(state.historial[state.historialIndice]));
      seleccionar(null);
      dibujar();
    }
  });

  document.getElementById('pz-btn-rehacer').addEventListener('click', function () {
    if (state.historialIndice < state.historial.length - 1) {
      state.historialIndice++;
      state.elementos = JSON.parse(JSON.stringify(state.historial[state.historialIndice]));
      seleccionar(null);
      dibujar();
    }
  });

  document.getElementById('pz-btn-limpiar').addEventListener('click', function () {
    if (!confirm('¿Seguro que quieres borrar todo el diseño?')) return;
    state.elementos = [];
    state.fondoColor = 'transparent';
    seleccionar(null);
    guardarHistorial();
    dibujar();
  });

  document.getElementById('pz-btn-exportar').addEventListener('click', function () {
    var link = document.createElement('a');
    link.download = 'diseno-calima.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  });

  document.querySelectorAll('.pz-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      document.querySelectorAll('.pz-tab').forEach(function (t) {
        t.classList.remove('pz-tab--activo');
        t.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.pz-panel__tab').forEach(function (p) {
        p.classList.add('pz-panel__tab--oculto');
      });
      tab.classList.add('pz-tab--activo');
      tab.setAttribute('aria-selected', 'true');
      var tabId = 'pz-tab-' + tab.getAttribute('data-tab');
      var panel = document.getElementById(tabId);
      if (panel) panel.classList.remove('pz-panel__tab--oculto');
    });
  });

  var form = document.getElementById('pz-form-carrito');
  if (form) {
    form.addEventListener('submit', function () {
      document.getElementById('pz-input-diseno').value = canvas.toDataURL('image/png');
      var nota = document.getElementById('pz-textarea-nota');
      if (nota) document.getElementById('pz-input-nota').value = nota.value;
    });
  }

  document.getElementById('pz-textarea-nota') && document.getElementById('pz-textarea-nota').addEventListener('input', function () {
    var inp = document.getElementById('pz-input-nota');
    if (inp) inp.value = this.value;
  });

  guardarHistorial();
  dibujar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-calima"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[id^="rs-seccion-"]').forEach(function (seccion) {
    var id = seccion.id.replace('rs-seccion-', '');
    var pista = document.getElementById('rs-pista-' + id);
    var carril = document.getElementById('rs-carril-' + id);
    var contenedorPuntos = document.getElementById('rs-puntos-' + id);
    var btnPrev = document.getElementById('rs-prev-' + id);
    var btnNext = document.getElementById('rs-next-' + id);

    if (!carril) return;

    var slides = Array.from(carril.querySelectorAll('.rs-slide'));
    var total = slides.length;
    var indice = 0;
    var visibles = 1;
    var anchoSlide = 0;
    var arrastrando = false;

    function calcularVisibles() {
      var w = window.innerWidth;
      if (w >= 990) visibles = 3;
      else if (w >= 749) visibles = 2;
      else visibles = 1;
    }

    function calcularAncho() {
      calcularVisibles();
      anchoSlide = slides[0] ? slides[0].offsetWidth : pista.offsetWidth / visibles;
    }

    function crearPuntos() {
      if (!contenedorPuntos) return;
      contenedorPuntos.innerHTML = '';
      var numPuntos = Math.max(1, total - visibles + 1);
      for (var i = 0; i < numPuntos; i++) {
        var btn = document.createElement('button');
        btn.className = 'rs-puntos__punto' + (i === 0 ? ' rs-puntos__punto--activo' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', 'Reseña ' + (i + 1));
        btn.setAttribute('data-indice', i);
        btn.addEventListener('click', function () {
          irA(parseInt(this.getAttribute('data-indice'), 10));
        });
        contenedorPuntos.appendChild(btn);
      }
    }

    function actualizarPuntos() {
      if (!contenedorPuntos) return;
      contenedorPuntos.querySelectorAll('.rs-puntos__punto').forEach(function (p, i) {
        p.classList.toggle('rs-puntos__punto--activo', i === indice);
      });
    }

    function actualizarFlechas() {
      if (btnPrev) btnPrev.disabled = indice <= 0;
      if (btnNext) btnNext.disabled = indice >= total - visibles;
    }

    function irA(idx) {
      var max = Math.max(0, total - visibles);
      indice = Math.min(Math.max(idx, 0), max);
      carril.style.transform = 'translateX(-' + (indice * anchoSlide) + 'px)';
      actualizarPuntos();
      actualizarFlechas();
    }

    calcularAncho();
    crearPuntos();
    irA(0);

    window.addEventListener('resize', function () {
      calcularAncho();
      crearPuntos();
      irA(Math.min(indice, Math.max(0, total - visibles)));
    });

    if (btnPrev) btnPrev.addEventListener('click', function () { irA(indice - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { irA(indice + 1); });

    var desdeX = null;
    var offsetX = 0;
    var umbral = 50;

    pista.addEventListener('mousedown', function (e) {
      desdeX = e.clientX;
      offsetX = 0;
      arrastrando = false;
      carril.style.transition = 'none';
    });
    window.addEventListener('mousemove', function (e) {
      if (desdeX === null) return;
      offsetX = e.clientX - desdeX;
      if (Math.abs(offsetX) > 5) arrastrando = true;
      carril.style.transform = 'translateX(' + (-indice * anchoSlide + offsetX) + 'px)';
    });
    window.addEventListener('mouseup', function () {
      if (desdeX === null) return;
      carril.style.transition = '';
      if (offsetX < -umbral) irA(indice + 1);
      else if (offsetX > umbral) irA(indice - 1);
      else irA(indice);
      desdeX = null;
    });
    pista.addEventListener('click', function (e) {
      if (arrastrando) e.preventDefault();
    }, true);

    pista.addEventListener('touchstart', function (e) {
      desdeX = e.touches[0].clientX;
      offsetX = 0;
      arrastrando = false;
      carril.style.transition = 'none';
    }, { passive: true });
    pista.addEventListener('touchmove', function (e) {
      if (desdeX === null) return;
      offsetX = e.touches[0].clientX - desdeX;
      if (Math.abs(offsetX) > 5) arrastrando = true;
      carril.style.transform = 'translateX(' + (-indice * anchoSlide + offsetX) + 'px)';
    }, { passive: true });
    pista.addEventListener('touchend', function () {
      if (desdeX === null) return;
      carril.style.transition = '';
      if (offsetX < -umbral) irA(indice + 1);
      else if (offsetX > umbral) irA(indice - 1);
      else irA(indice);
      desdeX = null;
    });

    seccion.querySelectorAll('.rs-tarjeta__leer-mas').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = btn.previousElementSibling;
        if (!p) return;
        var completo = p.getAttribute('data-texto-completo');
        var corto = p.getAttribute('data-texto-corto');
        if (btn.textContent.trim() === 'Leer más') {
          p.textContent = completo;
          btn.textContent = 'Leer menos';
        } else {
          p.textContent = corto;
          btn.textContent = 'Leer más';
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-productos-calima"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[id^="sp-seccion-"]').forEach(function (seccion) {
    var id = seccion.id.replace('sp-seccion-', '');
    var pista = document.getElementById('sp-pista-' + id);
    var carril = document.getElementById('sp-carril-' + id);
    var contenedorPuntos = document.getElementById('sp-puntos-' + id);
    var btnPrev = document.getElementById('sp-prev-' + id);
    var btnNext = document.getElementById('sp-next-' + id);

    if (!carril) return;

    var slides = Array.from(carril.querySelectorAll('.sp-slide'));
    var total = slides.length;
    var indice = 0;
    var visibles = 1;
    var anchoSlide = 0;
    var arrastrando = false;

    function calcularVisibles() {
      var w = window.innerWidth;
      if (w >= 990) visibles = 4;
      else if (w >= 749) visibles = 2;
      else visibles = 1;
    }

    function calcularAncho() {
      calcularVisibles();
      anchoSlide = slides[0] ? slides[0].offsetWidth : pista.offsetWidth / visibles;
    }

    function crearPuntos() {
      if (!contenedorPuntos) return;
      contenedorPuntos.innerHTML = '';
      var numPuntos = Math.max(1, total - visibles + 1);
      for (var i = 0; i < numPuntos; i++) {
        var btn = document.createElement('button');
        btn.className = 'sp-puntos__punto' + (i === 0 ? ' sp-puntos__punto--activo' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', 'Producto ' + (i + 1));
        btn.setAttribute('data-indice', i);
        btn.addEventListener('click', function () {
          irA(parseInt(this.getAttribute('data-indice'), 10));
        });
        contenedorPuntos.appendChild(btn);
      }
    }

    function actualizarPuntos() {
      if (!contenedorPuntos) return;
      contenedorPuntos.querySelectorAll('.sp-puntos__punto').forEach(function (p, i) {
        p.classList.toggle('sp-puntos__punto--activo', i === indice);
      });
    }

    function actualizarFlechas() {
      if (btnPrev) btnPrev.disabled = indice <= 0;
      if (btnNext) btnNext.disabled = indice >= total - visibles;
    }

    function irA(idx) {
      var max = Math.max(0, total - visibles);
      indice = Math.min(Math.max(idx, 0), max);
      carril.style.transform = 'translateX(-' + (indice * anchoSlide) + 'px)';
      actualizarPuntos();
      actualizarFlechas();
    }

    calcularAncho();
    crearPuntos();
    irA(0);

    window.addEventListener('resize', function () {
      calcularAncho();
      crearPuntos();
      irA(Math.min(indice, Math.max(0, total - visibles)));
    });

    if (btnPrev) btnPrev.addEventListener('click', function () { irA(indice - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { irA(indice + 1); });

    var desdeX = null;
    var offsetX = 0;
    var umbral = 50;

    pista.addEventListener('mousedown', function (e) {
      desdeX = e.clientX;
      offsetX = 0;
      arrastrando = false;
      carril.style.transition = 'none';
    });

    window.addEventListener('mousemove', function (e) {
      if (desdeX === null) return;
      offsetX = e.clientX - desdeX;
      if (Math.abs(offsetX) > 5) arrastrando = true;
      carril.style.transform = 'translateX(' + (-indice * anchoSlide + offsetX) + 'px)';
    });

    window.addEventListener('mouseup', function () {
      if (desdeX === null) return;
      carril.style.transition = '';
      if (offsetX < -umbral) irA(indice + 1);
      else if (offsetX > umbral) irA(indice - 1);
      else irA(indice);
      desdeX = null;
    });

    pista.addEventListener('click', function (e) {
      if (arrastrando) e.preventDefault();
    }, true);

    pista.addEventListener('touchstart', function (e) {
      desdeX = e.touches[0].clientX;
      offsetX = 0;
      arrastrando = false;
      carril.style.transition = 'none';
    }, { passive: true });

    pista.addEventListener('touchmove', function (e) {
      if (desdeX === null) return;
      offsetX = e.touches[0].clientX - desdeX;
      if (Math.abs(offsetX) > 5) arrastrando = true;
      carril.style.transform = 'translateX(' + (-indice * anchoSlide + offsetX) + 'px)';
    }, { passive: true });

    pista.addEventListener('touchend', function () {
      if (desdeX === null) return;
      carril.style.transition = '';
      if (offsetX < -umbral) irA(indice + 1);
      else if (offsetX > umbral) irA(indice - 1);
      else irA(indice);
      desdeX = null;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trabajos-realizados"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[id^="tr-seccion-"]').forEach(function (seccion) {
    var id = seccion.id.replace('tr-seccion-', '');
    var pista = document.getElementById('tr-pista-' + id);
    var carril = document.getElementById('tr-carril-' + id);
    var contenedorPuntos = document.getElementById('tr-puntos-' + id);
    var btnPrev = document.getElementById('tr-prev-' + id);
    var btnNext = document.getElementById('tr-next-' + id);

    if (!carril) return;

    var slides = Array.from(carril.querySelectorAll('.tr-slide'));
    var puntos = contenedorPuntos ? Array.from(contenedorPuntos.querySelectorAll('.tr-puntos__punto')) : [];
    var total = slides.length;
    var indiceActual = 0;
    var anchoSlide = 0;
    var visibles = 1;

    function calcularVisibles() {
      var w = window.innerWidth;
      if (w >= 990) visibles = 3;
      else if (w >= 749) visibles = 2;
      else visibles = 1;
      anchoSlide = slides[0] ? slides[0].offsetWidth : pista.offsetWidth / visibles;
    }

    function irA(idx) {
      var maxIdx = Math.max(0, total - visibles);
      indiceActual = Math.min(Math.max(idx, 0), maxIdx);
      carril.style.transform = 'translateX(-' + (indiceActual * anchoSlide) + 'px)';
      puntos.forEach(function (p, i) {
        p.classList.toggle('tr-puntos__punto--activo', i === indiceActual);
        p.setAttribute('aria-selected', i === indiceActual ? 'true' : 'false');
      });
      if (btnPrev) btnPrev.style.opacity = indiceActual === 0 ? '0.4' : '1';
      if (btnNext) btnNext.style.opacity = indiceActual >= total - visibles ? '0.4' : '1';
    }

    calcularVisibles();
    irA(0);

    if (btnPrev) btnPrev.addEventListener('click', function () { irA(indiceActual - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { irA(indiceActual + 1); });

    puntos.forEach(function (p, i) {
      p.addEventListener('click', function () { irA(i); });
    });

    /* Arrastre táctil y mouse */
    var startX = 0, isDragging = false;
    pista.addEventListener('mousedown', function (e) { startX = e.clientX; isDragging = true; });
    pista.addEventListener('mousemove', function (e) { if (isDragging) e.preventDefault(); });
    pista.addEventListener('mouseup', function (e) {
      if (!isDragging) return;
      isDragging = false;
      var diff = startX - e.clientX;
      if (Math.abs(diff) > 40) irA(diff > 0 ? indiceActual + 1 : indiceActual - 1);
    });
    pista.addEventListener('mouseleave', function () { isDragging = false; });

    pista.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    pista.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) irA(diff > 0 ? indiceActual + 1 : indiceActual - 1);
    }, { passive: true });

    window.addEventListener('resize', function () {
      calcularVisibles();
      carril.style.transition = 'none';
      irA(indiceActual);
      setTimeout(function () { carril.style.transition = ''; }, 50);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
